<template>
  <div class="form-collapse" style="margin-top:20px">
    <div class="info">
      <layui-form ref="storageBrowserForm"   :showForm="true">
        <template slot-scope="{scope}">
          <div class="layui-form">
            <template>
              <div class="layui-colla-item">
                <h2 class="layui-colla-title">资料库基本信息</h2>
                <div class="layui-colla-content layui-show">
                  <div class="layui-form-item-one">
                    <div class="layui-form-item">
                      <label class="layui-form-label">资料名称：</label>
                      <div class="layui-input-inline" style="width: 60%; padding-top: 7px">
                        {{config.form.STORAGE_NAME}}
                      </div>
                    </div>
                    <div class="layui-form-item">
                      <label class="layui-form-label">资料列表：</label>
                      <div class="layui-input-inline" style="width: 60%">
                        <layui-listfileupload :enabled="false" v-model="config.form.STORAGE_FILES" targetEl=".siteForm" name="STORAGE_FILES"/>
                      </div>
                    </div>
                    <div class="layui-form-item">
                      <label class="layui-form-label">所属品牌：</label>
                      <div class="layui-input-inline" style="width: 60%">
                        <layui-multiselect
                          requestUniqueId="getBrandList_tmp"
                          :single="true"
                          ref="brandSelect"
                          :enabled="false"
                          name=""
                          :renderText="renderBrandRow"
                          table-name="YW_BRAND_DETAIL_V"
                          text-field="BRAND_NAME"
                          value-field="BRAND_ID"
                          :show-null-option="true"
                          :queryCondition="{}"
                          selectFields="BRAND_ID,CLIENT_NAME,CLIENT_ID,BRAND_NAME"
                          :enable-search="true"
                          :sort="[]"
                          v-model="config.form.BRAND_ID"
                        ></layui-multiselect>
                      </div>
                    </div>

                    <div class="layui-form-item" style="margin-top: 30px">
                      <label class="layui-form-label">备注：</label>
                      <div class="layui-input-inline" style="width: 60%; padding-top: 7px">
                        {{config.form.STORAGE_REMARK}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="layui-form-btn">
            <div class="layui-footer">
              <button class="layui-btn refresh" title="关闭" @click="cancelOnClick()">
                关 闭
              </button>
            </div>
          </div>
        </template>
      </layui-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      config: {
        form: {}
      },
    }
  },
  mounted () {
    if(this.tabParam) {
      this.config.form = this.tabParam.editRow
    }

  },
  methods: {
    renderBrandRow: function (row) {
      if (row) {
        return `<div>${row.BRAND_NAME}【${row.CLIENT_NAME}】</div>`
        var width = $("#manager").width() - 20 - 12 - 30;
        var content = ''
        if(row['MANAGER_PHONE']){
          content = row['MANAGER_NAME'] + "【" + row['MANAGER_PHONE'] + "】";
        } else {
          content = row['MANAGER_NAME'];
        }
        return  '<div style="white-space: nowrap;max-width:'+ width +'px;overflow: hidden;" title="'+ content +'">' + content + "</div>";

      }
      return ''
    },
    cancelOnClick() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu);
      this.baseComponent.loadComponentByName('storage');
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/workOrder/storage/storageBrowserForm.vue